import { inject, Injectable } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { Languages } from "../models/languages.model";
import { LanguagesApi } from "./languages.api";

@Injectable()
export class LanguagesTypeaheadApi extends NiceAsyncTypeaheadProvider<Languages> {
    private readonly languagesApi = inject(LanguagesApi);

    public readonly resource = "languages";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<Languages> {
        return lastValueFrom(this.languagesApi.getById(id));
    }

    public override search(searchQuery: string, page: number): Observable<NiceAsyncTypeaheadSearchResult<Languages>> {
        const dto: FindOptionsDto = {
            page,
            pageSize: this.pageSize,
            searchQuery
        };

        return this.languagesApi.search(dto).pipe(
            map((items) => ({
                items,
                nextPage: items.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: Languages): string {
        if (!isPropertyDefined(item, "abbreviation")) {
            return "";
        }

        return item.abbreviation.toUpperCase();
    }
}
